var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeBlack2424 = function SvgHomeBlack2424(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "home_black_24_24_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home_black_24_24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "M6 19h3.346v-5.039q0-.383.26-.643a.88.88 0 0 1 .644-.26h3.5q.384 0 .644.26t.26.643V19H18v-8.846a.3.3 0 0 0-.034-.14.4.4 0 0 0-.091-.11l-5.692-4.279A.27.27 0 0 0 12 5.558a.27.27 0 0 0-.183.067L6.125 9.904a.4.4 0 0 0-.091.11.3.3 0 0 0-.034.14zm-1.5 0v-8.846a1.8 1.8 0 0 1 .723-1.446l5.693-4.289a1.74 1.74 0 0 1 1.082-.361q.61 0 1.087.361l5.692 4.289q.339.248.531.632t.192.814V19q0 .613-.443 1.057A1.44 1.44 0 0 1 18 20.5h-3.942a.87.87 0 0 1-.644-.26.87.87 0 0 1-.26-.644v-5.038h-2.308v5.038q0 .383-.26.644a.87.87 0 0 1-.644.26H6q-.613 0-1.057-.443A1.44 1.44 0 0 1 4.5 19"
  }))));
};
export default SvgHomeBlack2424;